<template>
	<div class="grid grid-cols-2 gap-x-4 gap-y-6 lg:flex-row">
		<sb-category-card-big
			v-for="category in categories"
			:key="category.uuid"
			:blok="category"
		/>
	</div>
</template>

<script setup lang="ts">
import {useStoryblokStoriesList} from "@pkg/shared/composables/use-storyblok-stories-list";

const properties = defineProps<{
	blok: string[];
}>();

const categoryUuids = [...properties.blok]
	.sort((a, b) => a.localeCompare(b))
	.join(",");

const {t} = useI18n();

const {
	data: {value: categories},
} = await useStoryblokStoriesList(`rooms-${categoryUuids}`, {
	starts_with: `${t("storyblok.rooms")}/`,
	by_uuids: categoryUuids,
});
</script>
